// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"226":"405a84e2","328":"b175c79e","489":"8be79e2b","848":"8783c961"}[chunkId] + ".chunk.js");